let appConfig = null;

export async function loadConfig() {
    const response = await fetch("/config.json");

    if (!response.ok) {
        throw new Error("Failed to load config.json");
    }

    appConfig = await response.json();
    return appConfig;
}

export function getConfig() {
    return appConfig;
}
